import React, { useState } from "react";

const PopularItems = ({
  handleGetCatlogItems,
  selectedBookingItemsFromCatlog,
  removeCatalogItem,
  selectCatalogItem,
}) => {
  const [search, setSearch] = useState("");
  const catlogItems = handleGetCatlogItems() || [];

  // Filter items based on search
  const filteredItems = catlogItems.filter((item) =>
    item?.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-container md:max-w-[500px] font-instrument">
      <h2 className="text-[#34318C] text-[18px] font-medium mb-[12px]">
        Popular items
      </h2>

      {/* Search Bar */}
      <div className="relative w-full mb-[31px]">
        <input
          type="text"
          placeholder="Search or add items"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="
    h-[43.97px] w-full pl-[40px] px-[10px] py-[8px]
    rounded-[11px]
    border border-[#CDCCD7]
    bg-[#E6E6E6]
    outline-none
    focus:outline-none
    focus:ring-0
    focus:border-[#7876A1]
    focus:shadow-[0_0_0_1px_#7876A1]
  "
        />


        <img
          src="/Vision Agent Icons/Search/Search.svg"
          alt="search icon"
          className="absolute left-[10px] top-1/2 transform -translate-y-1/2 w-[20px] h-[20px] pointer-events-none"
        />
      </div>

      {/* Grid Layout - 4 columns on mobile, 6 on web */}
      <div className="grid grid-cols-4 md:grid-cols-6 gap-[10px]">
        {filteredItems.length ? (
          filteredItems.map((item) => {
            const isSelected = selectedBookingItemsFromCatlog
              .map((it) => it.itemId)
              .includes(item.itemId);

            return (
              <div
                key={item.itemId}
                className={`cursor-pointer flex flex-col items-center ${isSelected ? "text-[#34318C]" : "text-[#7876A1]"
                  }`}
                onClick={
                  isSelected
                    ? () => removeCatalogItem(item)
                    : () => selectCatalogItem(item)
                }
              >
                <div
                  className={`w-[68px] h-[68px] rounded-full flex items-center border-[2px] justify-center ${isSelected ? "border-[2px] border-[#7876A1]" : "bg-[#C8C6DF]"
                    }`}
                >
                  <img
                    src={item?.imageURL || "/images/moovez_frog.png"}
                    alt={item?.name || "item"}
                    className="w-[100%] h-[100%] rounded-full object-cover"
                  />
                </div>
                <span className="text-[12px] text-center mt-[4px] capitalize break-words w-full px-1">
                  {item?.name}
                </span>
              </div>
            );
          })
        ) : (
          <div className="col-span-4 md:col-span-6">
            <p className="text-[#7876A1] text-[14px] text-center">
              No items found
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopularItems;
